export default "__VITE_ASSET__DP7UCcKY__"